// NPM Imports
import React, { useContext } from 'react'
// Quote Context
import { useQuoteContext } from '../../../hooks/useQuoteContext'
// Component Imports
// JS Imports
import { formatFloatAsCurrencySymbol } from '../../../common/helpers.mjs'
// Asset Imports

export default function TestAccountRow() {
   const state = useQuoteContext()
   const permissions = state.featurePermissions['TestAccount']

   if (state.product_list['testAccount']?.NotInPricebook) {
      return <> </>
   }

   if (
      (permissions.includes(state.user_role) || state.productTestAccount) &&
      'testAccount' in state.product_list
   )
      return (
         <div className='row'>
            <div className='col-bhr1'>
               {state.product_list['testAccount']['ProductName']}
            </div>
            <div className='col-bhr2'>
               <input
                  className='input-field'
                  type='checkbox'
                  checked={state.productTestAccount}
                  onChange={() => state.setProductTestAccount((prev) => !prev)}
               ></input>
            </div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'></div>
            <div className='col'>
               {formatFloatAsCurrencySymbol(
                  state.TestAccountCosts.totalPrice,
                  state.currencyObject,
               )}
            </div>
            {state.differenceQuote == true ? (
               <>
                  <div className='col'></div>
                  <div className='col'></div>
               </>
            ) : (
               <></>
            )}
         </div>
      )
}
